module.exports = __webpack_public_path__ + "img/noData.1a6a4ff0.png";